// extracted by mini-css-extract-plugin
export default {"tableLayoutFixed":"DiffLines-module__tableLayoutFixed--InKAb","compact":"DiffLines-module__compact--emLm8"};